import React from "react";

const Header = () => {
  return (
    <>
      <section className="header__section">
        <h1>Todo App🙌</h1>
        <h1>
          <a
            href="https://github.com/Ebraj/todo-app-using-react"
            target="blank"
          >
            Github Repo!
          </a>
        </h1>
      </section>
    </>
  );
};

export default Header;
